<app-topbar></app-topbar>
<!-- <div>
    <img src="assets/images/svg/contact33.png" class="hero-image">
    <div class="contact-location" id="Team" style="margin-top: 80px; margin-bottom:10px;">
		<div class="container">
			<div class="row">
				<div class="col-lg-6 col-12">
					<div class="location-map">
						<div id="map">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d972.1451239934555!2d77.61397652918603!3d12.934662199430011!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15da5ac35ce9%3A0x65a4d5e2992044c7!2sBuymore%20Infotech%20Private%20Limited!5e0!3m2!1sen!2sin!4v1664341652467!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
						</div>
					</div>
				</div>
				<div class="col-lg-6 col-12">
					<div class="contact-form">
						<form  id="commentform" class="comment-form" [formGroup]="QueryForm">
							<input type="text" name="name" class="mt-2" placeholder="Name*" id="name" formControlName="name">
							<input type="email" name="email" class="mt-2" placeholder="Email*" id="email"  formControlName="email">
							<input type="text" name="company" class="mt-2" placeholder="Company name*" id="text" formControlName="subject">
							<input type="text" name="phone_nu" class="mt-2" placeholder="Contact*" id="phone_nu" formControlName="phone_nu" maxlength="10" minlength="10" (keypress)="numericOnly($event)" (paste)="onPaste($event)"  > 
							<textarea name="message" id="role" cols="30" rows="11" placeholder="Message*"  class="mt-2"  formControlName="message"></textarea>
							<button type="submit" class="contact-btn" id="submit-btn" (click)="formsubmit()" [disabled]="QueryForm.invalid"  [ngClass]="{'button-disabled': QueryForm.invalid, 'button-enabled': !QueryForm.invalid}">
								<span>Submit Now</span>
							</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</div> -->
<div>
	<div class="headerOne">
		<div class="container" style="margin-top: 150px;">
			<div class="row">
				<div class="col-md-6">
					<p class="headingText"> We Are Buymore D2C — More Than Just a Fulfillment Partner. </p>
					<ul class="text-blackdark list-style-type-none font-16 mt-4 pl-0" style="line-height: 35px; list-style: none;">
						<li>
							<img class="cir" style="filter: grayscale(1);" src="assets/images/svg/correct11.png" alt="checkCircle" width="20px" height="20px">
							<span class="SFProDisplay-Medium blck ms-2">Sales growth strategies to maximize profits and reduce costs</span>
						</li>
						<li>
							<img class="cir" style="filter: grayscale(1);" src="assets/images/svg/correct11.png" alt="checkCircle" width="20px" height="20px">
							<span class="SFProDisplay-Medium blck ms-2">AI-driven RTO and NDR management for smarter logistics</span>
						</li>
						<li>
							<img class="cir" style="filter: grayscale(1);" src="assets/images/svg/correct11.png" alt="checkCircle" width="20px" height="20px">
							<span class="SFProDisplay-Medium blck ms-2">Multi-channel unified inventory with virtual bundling</span>
						</li>
						<li>
							<img class="cir" style="filter: grayscale(1);" src="assets/images/svg/correct11.png" alt="checkCircle" width="20px" height="20px">
							<span class="SFProDisplay-Medium blck ms-2">Custom website features and seamless API integrations</span>
						</li>
						<li>
							<img class="cir" style="filter: grayscale(1);" src="assets/images/svg/correct11.png" alt="checkCircle" width="20px" height="20px">
							<span class="SFProDisplay-Medium blck ms-2">SEO optimization and SEM channel strategy</span>
						</li>
						<li>
							<img class="cir" style="filter: grayscale(1);" src="assets/images/svg/correct11.png" alt="checkCircle" width="20px" height="20px">
							<span class="SFProDisplay-Medium blck ms-2">Paperless warehousing and intelligent inventory management</span>
						</li>
						<li>
							<img class="cir" style="filter: grayscale(1);" src="assets/images/svg/correct11.png" alt="checkCircle" width="20px" height="20px">
							<span class="SFProDisplay-Medium blck ms-2">AI/ML and data analytics for performance-driven advertising</span>
						</li>
					</ul>



				</div>
				<div class="col-md-6">
					<div class="card p-4" style="background-color: white;border-radius: 15px;">
						<p class="headingText1">Get A Demo</p>

						<form [formGroup]="demoForm" (ngSubmit)="submit_demo()">
							<div class="row">
								<div class="col-md-6">
									<label>First Name</label>
									<input type="text" formControlName="first_name" placeholder="First Name" class="form-control mt-2">
								</div>
								<div class="col-md-6">
									<label>Last Name</label>
									<input type="text" formControlName="last_name" placeholder="Last Name" class="form-control mt-2">
								</div>
							</div>

							<div class="row">
								<div class="col-md-6">
									<label>Email Id</label>
									<input type="email" formControlName="email" placeholder="Email Id" class="form-control mt-2">
								</div>
								<div class="col-md-6">
									<label>Phone Number</label>
									<input type="text" formControlName="phone" placeholder="Phone Number" class="form-control mt-2" (keypress)="numericOnly($event)">
								</div>
							</div>

							<div class="row">
								<div class="col-12">
									<label>Message</label>
									<textarea formControlName="message" rows="5" placeholder="Message" class="form-control mt-2"></textarea>
								</div>
							</div>

							<button type="submit" class="bg demo-btn w-100 border-0 p-2 mt-4" style="color: white; border-radius: 15px;">
								Submit
							</button>
						</form>
					</div>
				</div>


			</div>

		</div>
	</div>
	<!-- <div class="container">
		<div class="row" style="margin-top: 60px;">
			<p class="headingText d-flex justify-content-center text-center"> There’s No Looking Back
			<p>
			<p class="content d-flex justify-content-center text-center"> Have your investments return, not your orders. Move forward with upto 45% lesser RTOs. </p>
		</div>
		<div class="row" style="align-items: center; margin-top: 40px;">
			<div class="col-md-6">
				<p class="headingText2"> Real-Time Tracking Updates </p>
				<p class="content1 d-flex justify-content-center"> Notify your buyers via Email & SMS </p>
			</div>
			<div class="col-md-6">
				<img src="assets/images/svg/de1.webp">
			</div>
		</div>
		<div class="row" style="align-items: center; margin-top: 40px;">
			<div class="col-md-6">
				<img src="assets/images/svg/de2.webp">
			</div>
			<div class="col-md-6">
				<p class="headingText2">AI-Powered RTO Prediction</p>
				<p class="content1 d-flex justify-content-center">Process undelivered orders within minutes</p>
			</div>
		</div>
		<div class="row" style="align-items: center; margin-top: 40px;">
			<div class="col-md-6">
				<p class="headingText2">Automated NDR Dashboard</p>
				<p class="content1 d-flex justify-content-center">Process undelivered orders within minutes</p>
			</div>
			<div class="col-md-6">
				<img src="assets/images/svg/de3.webp">
			</div>
		</div>
	</div>
	<div class="container">
		<div class="row" style="margin-top: 60px;">
			<p class="headingText d-flex justify-content-center text-center">Power At Your Fingertips
			<p>
			<p class="content d-flex justify-content-center text-center">Fantastic features to make eCommerce shipping an easy-peasy task.</p>
		</div>
		<div class="row" style="margin-top: 40px;">
			<div class="col-md-4">
				<img src="assets/images/svg/de4.svg" width="60px" height="60px">
				<p class="content2 mt-3">All-In-One Dashboard </p>
				<p class="content3"> Manage your orders, shipments, NDR, RTO in one place. </p>
			</div>
			<div class="col-md-4">
				<img src="assets/images/svg/de5.svg" width="60px" height="60px">
				<p class="content2 mt-3">Shipping Rate Calculator</p>
				<p class="content3">Calculate shipping rates based on the delivery distance & shipping mode.</p>
			</div>
			<div class="col-md-4">
				<img src="assets/images/svg/de6.svg" width="60px" height="60px">
				<p class="content2 mt-3">Lowest Shipping Rates</p>
				<p class="content3">Start shipping at ₹20/500gms* domestically & ₹110/50gms*</p>
			</div>
		</div>
		<div class="row" style="margin-top: 40px;">
			<div class="col-md-4">
				<img src="assets/images/svg/de7.svg" width="60px" height="60px">
				<p class="content2 mt-3">Quick Order Processing</p>
				<p class="content3">Create shipments, download documents & schedule pickups in a few clicks.</p>
			</div>
			<div class="col-md-4">
				<img src="assets/images/svg/de8.svg" width="60px" height="60px">
				<p class="content2 mt-3">Multiple Pickup Locations</p>
				<p class="content3">Add unlimited pickup locations to your account & ship conveniently.</p>
			</div>
			<div class="col-md-4">
				<img src="assets/images/svg/de9.svg" width="60px" height="60px">
				<p class="content2 mt-3">29k+ Serviceable Pin Codes</p>
				<p class="content3">Reach far-off cities with ease & take your business to every household.</p>
			</div>
		</div>
		<div class="row" style="margin-top: 40px; margin-bottom: 40px;">
			<div class="col-md-4">
				<img src="assets/images/svg/de10.svg" width="60px" height="60px">
				<p class="content2 mt-3">Insurance Cover Upto ₹25L</p>
				<p class="content3">Get 100%* insurance cover for lost & damaged shipments worth ₹5K- ₹25L</p>
			</div>
			<div class="col-md-4">
				<img src="assets/images/svg/de11.svg" width="60px" height="60px">
				<p class="content2 mt-3">Early COD Remittance</p>
				<p class="content3">Get guaranteed remittance in 2 days* & unrestrict your cash flow</p>
			</div>
			<div class="col-md-4">
				<img src="assets/images/svg/de12.svg" width="60px" height="60px">
				<p class="content2 mt-3">Bulk Uploads</p>
				<p class="content3">Upload several orders in one file & eliminate manual efforts</p>
			</div>
		</div>
	</div> -->
</div>
<app-footer></app-footer>
<ng-container *ngIf="showOverlay" id="overlay-container">
	<app-spinner [overlay]="true" id="loader"></app-spinner>
</ng-container>